import { ActionTree } from "vuex";
import { PosteActionsTypes, PosteMutationsTypes } from "./types";
import { Poste, PosteActions, PosteState, CreateMultiplePoste, PosteDelete } from "./interface";
import Client from "@/plugins/axios/axios";
import { Response_ } from "@/plugins/axios/response";

export const actions: ActionTree<PosteState, PosteState> & PosteActions = {
  [PosteActionsTypes.LIST_POSTE]: async ({ commit }): Promise<void> => {
    return Client.get<void, Response_>(`poste/list`).then((response: Response_) =>
      commit(PosteMutationsTypes.SET_POSTE, response.body as Array<Poste>)
    );
  },
  [PosteActionsTypes.LIST_POSTE_BY_MATERIAL]: async ({ commit }, material_id: string): Promise<void> => {
    return Client.get<void, Response_>(`poste/list/material/${material_id}`).then((response: Response_) =>
      commit(PosteMutationsTypes.SET_POSTE, response.body as Array<Poste>)
    );
  },
  [PosteActionsTypes.LIST_POSTE_BY_SURVEY]: async ({ commit }, survey_id: string): Promise<void> => {
    return Client.get<void, Response_>(`poste/list/survey/${survey_id}`).then((response) =>
      commit(PosteMutationsTypes.SET_POSTE, response.body as Array<Poste>)
    );
  },
  [PosteActionsTypes.CREATE_POSTES]: async ({ commit }, postes: CreateMultiplePoste): Promise<Response_> => {
    return Client.post<Response_, Response_>(`poste/${postes.survey_id}`, postes.postes)
      .then((response) => {
        commit(PosteMutationsTypes.SET_POSTE, response.body as Array<Poste>);
        return response;
      })
      .catch((err: Response_) => err);
  },
  [PosteActionsTypes.DELETE_POSTE]: async ({ commit }, poste_delete: PosteDelete): Promise<Response_> => {
    return Client.delete<Response_, Response_>(`poste/${poste_delete.survey_id}/${poste_delete.poste_id}`)
      .then((response) => {
        commit(PosteMutationsTypes.DELETE_POSTE, poste_delete.poste_id);
        return response;
      })
      .catch((err: Response_) => err);
  },
  [PosteActionsTypes.CREATE_POSTE]: async ({ commit }, poste_create: any): Promise<Response_> => {
    return Client.post<Response_, Response_>(`poste/${poste_create.survey}/create`, poste_create)
      .then((response) => {
        commit(PosteMutationsTypes.CREATE_POSTE, response.body as Poste);
        return response;
      })
      .catch((err: Response_) => err);
  },
  [PosteActionsTypes.UPDATE_POSTE]: async ({ commit }, poste_update: Poste): Promise<Response_> => {
    return Client.put<Response_, Response_>(`poste/${poste_update.survey}/${poste_update._id}/update`, poste_update)
      .then((response) => {
        commit(PosteMutationsTypes.UPDATE_POSTE, response.body as Poste);
        return response;
      })
      .catch((err: Response_) => err);
  }
};
